export interface GOLD_CITY {
  last_ten_days_data: GOLD_DATA[];
  today: GOLD_DATA;
  major_cities_data?: GOLD_DATA[];
}

export interface GOLD_DATA {
  date: string;
  city: string;
  carat24: CARAT_DATA;
  carat22: CARAT_DATA;
  carat18: CARAT_DATA;
  carat14: CARAT_DATA;
  carat12: CARAT_DATA;
  carat9: CARAT_DATA;
}

export interface CaratChange {
  change22k: number;
  change24k: number;
}

export interface CARAT_DATA {
  ratePerGram: number;
  change: number;
}

//Silver

export interface SILVER_CITY {
  last_ten_days_data: SILVER_DATA[];
  today: SILVER_DATA;
}

export interface SILVER_DATA extends CARAT_DATA {
  date: string;
  city: string;
}

export interface ALL_CITIES {
  major_city: string[];
  metro_city: string[];
  capital?: string[];
  country: string[];
}

export interface GRAM_WISE_CARAT_RATE {
  carat: string;
  rate: number;
  change: number;
  interval?: string;
}

export interface GRAM_WISE_SINGLE_CARAT_DATA {
  weight: string;
  rate: number;
  change: number;
}

export interface GoldCalculatorProps {
  data: GOLD_DATA;
}
export type CaratKey = '24k' | '22k' | '18k' | '14k' | '12k' | '9k';

export interface UseGoldCalculatorReturn {
  selectedCarat: CaratKey;
  setSelectedCarat: React.Dispatch<React.SetStateAction<CaratKey>>;
  isWeightToAmount: boolean;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  ratePerGram: number;
  calculateResult: () => string;
  handleSwap: () => void;
}

export enum METALS {
  GOLD = 'gold',
  SILVER = 'silver',
}

export enum INTERVALS {
  '1W' = '1W',
  '1M' = '1M',
  '1Y' = '1Y',
  '3Y' = '3Y',
  '5Y' = '5Y',
  '40Y' = '40Y',
}

export enum GOLD_CARATS {
  'GOLD24K' = 'gold24k',
  'GOLD22K' = 'gold22k',
}

export interface FormattedFAQ {
  header: string;
  content: string;
}

export interface CMSMeta {
  meta_title: string;
  description: string;
  keywords: string;
  title: string;
}

export interface GoldSilverPageProps {
  city: string;
  date: string;
  data: GOLD_CITY | SILVER_CITY;
  cities: ALL_CITIES;
  graphData: number[][];
}

export interface GoldSilverPageDataProps {
  props: GoldSilverPageProps;
}

export interface GoldSilverLayoutProps {
  city: string;
  date?: string;
  data: GOLD_CITY | SILVER_CITY;
  cities: ALL_CITIES;
  graphData: number[][];
  top_cta: string;
  cmsContent?: string;
  cmsFaq?: FormattedFAQ[];
  cmsMeta?: CMSMeta;
}

export interface GOLD_CITY_HOMEPAGE_PROPS {
  goldData: GOLD_CITY;
  cityData: ALL_CITIES;
  city: { type: string; name: string };
  graphData: number[][];
  metal: METALS;
  top_cta: string;
  cmsContent?: string;
  cmsFaq?: FormattedFAQ[];
  cmsTitle?: string;
}

export interface SILVER_CITY_HOMEPAGE_PROPS {
  goldData: SILVER_CITY;
  cityData: ALL_CITIES;
  city: { type: string; name: string };
  graphData: number[][];
  metal: METALS;
  top_cta: string;
  cmsContent?: string;
  cmsFaq?: FormattedFAQ[];
  cmsTitle?: string;
}
